(function () {
    'use strict';

    angular.module('Services').factory('ZoneBaseMarginsTableService', ZoneBaseMarginsTableService);

    ZoneBaseMarginsTableService.$inject = [
        'toastr', 
        'Carrier', 
        '$q', 
        '$timeout', 
        '$filter',
        '$rootScope'
    ];

    // TODO: I MAY NEED TO CLEANUP THIS ONE
    function ZoneBaseMarginsTableService(
        toastr, 
        Carrier, 
        $q, 
        $timeout, 
        $filter,
        $rootScope
    ) {
        return function (form, clientService) {
            let service = clientService;
            let dataCopy = [];
            const tableStructure = {
                config: {
                    noFooter: true,
                    noExtraction: true,
                    noTopOptions: true,
                    tableMinHeight: '15em'
                },
                form: form,
                headers: [{
                    label: 'Zone From',
                    viewName: 'zoneFrom'
                }, {
                    label: 'Zone To',
                    viewName: 'zoneTo'
                }, {
                    label: 'Fixed Margin',
                    viewName: 'fixedMargin'
                }, {
                    label: 'Margin %',
                    viewName: 'percentMargin'
                }, {
                    label: 'Actions',
                    viewName: 'actions'
                }],
                data: [],
                onInit: ()=>{
                    $timeout(()=>{
                        buildTableData(angular.getObjVal(clientService, 'zoneMargins.regions') || [], clientService, true);
                    });
                },
                clearZones: row=>{
                    row.zoneTo.valTemp = null;
                    row.zoneFrom.valTemp = null;
                },
                roundDown: model =>{
                    return parseFloat(parseFloat(model).roundDown(2))
                },
                zoneTooltip: '',
                searchZone: (select, row, col)=>{
                    row.isSearching = true;
                    if(select.open){
                        row.items = [];
                        if(angular.isDefined(clientService.carrierProfile)){
                            getZones().then(function(data){
                                $timeout(()=>data.map(item => row.items.push(item)));
                                row.isSearching = false;
                            });
                        } else {
                            row.isSearching = false;
                        }
                    } else {
                        row.isSearching = false;
                    }
                }
            };

            function getZones() {
                const defer = $q.defer();
                Carrier.getZonePostcodeFileDetail(clientService.carrierProfile.id, function(data){
                    defer.resolve(data.content);
                }, function(error){
                    defer.reject(error);
                    toastr.error(error.message, error.code);
                },
                { 
                    size: 200,
                    page: 0,
                    sort: 'code,desc'
                });
                return defer.promise;
            }

            function changeButtons(row) {
                if (row.editMode) {
                    row.actions.buttons[0].class = 'btn btn-success btn-circle glyphicon glyphicon-ok';
                    row.actions.buttons[1].class = 'btn btn-danger btn-circle glyphicon glyphicon-remove';
                    return false;
                }
                row.actions.buttons[0].class = 'btn btn-primary btn-circle glyphicon glyphicon-pencil';
                row.actions.buttons[1].class = 'btn btn-danger btn-circle glyphicon glyphicon-trash';
            }

            // TODO: I THINK WE DON'T NEED THIS ONE
            function buildStates (codes) {
                let distinctCodes = [];
                angular.forEach(codes, function(code, key){
                    if(codes[key-1] && code.code === codes[key-1].code){
                        distinctCodes[distinctCodes.length - 1].altStates.push(angular.copy(code));
                    }else{
                        code.altStates = [angular.copy(code)];
                        distinctCodes.push(angular.copy(code));
                    }
                });
                return distinctCodes;
            }

            let zone = {
                url: '/templates/pages/services/add-ons/tableBody/editableZone.html',
                value: null
            };

            let marginValue = {
                url: '/templates/pages/services/add-ons/tableBody/editableText.html',
                value: null
            };

            let actionBtns = function (isNew) {
                return {
                    type: 'button',
                    buttons: [{
                        class: isNew ? 'btn btn-success btn-circle glyphicon glyphicon-ok':
                            'btn btn-primary btn-circle glyphicon glyphicon-pencil',
                        action: row => {
                            tableStructure.form.$setSubmitted();
                            if(tableStructure.form.$invalid) {
                                return false;
                            }

                            row.isSelected = false;
                            
                            $timeout(()=>{
                                // TODO: NEED TO CHECK FOR DUPLICATE DATA IN THE TABLE
                                if(!row.editMode){
                                    tableStructure.form.$setUntouched();
                                    tableStructure.form.$setPristine();
                                    tableStructure.headers.map(header=>{
                                        row[header.viewName].valTemp = angular.copy(row[header.viewName].value);
                                    });
                                    row.editMode = !row.editMode;
                                }else{
                                    if(tableStructure.form.$valid){
                                        tableStructure.headers.map(header=>{
                                            row[header.viewName].value = angular.copy(row[header.viewName].valTemp) || 0;
                                            row[header.viewName].valueFormatted =
                                                (angular.copy(row[header.viewName].valTemp) || 0)
                                                + (header.viewName === 'fixedMargin' ? ' '
                                                + (service.serviceProfile.currency || 'AUD'): ' %');
                                        });
                                        row.editMode = !row.editMode;
                                    }
                                }
                                changeButtons(row);
                                $rootScope.$broadcast('postcodeMarginsTableUpdated', 'updated'); // EVENT BROADCASTER
                            });
                        }
                    }, {
                        class: isNew ? 'btn btn-danger btn-circle glyphicon glyphicon-remove'
                            : 'btn btn-danger btn-circle glyphicon glyphicon-trash',
                        action: row => {
                            if(row.editMode && !row.isNewMargin) {
                                row.editMode = false;
                                changeButtons(row);
                                return false;
                            }
                            tableStructure.data.splice(tableStructure.data.indexOf(row), 1);
                            $rootScope.$broadcast('postcodeMarginsTableUpdated', 'updated'); // EVENT BROADCASTER
                        }
                    }]
                };
            };

            function buildTableData(items, clientService, createCopy) {
                service = clientService;
                angular.forEach(items, function (row, index) {
                    row.actions = actionBtns();
                    row.fixedMargin = angular.extend(angular.copy(marginValue), {
                        value: row.marginFixed,
                        valueFormatted: $filter('bbaCurrency')(row.marginFixed, service.serviceProfile.currency),
                        addOn: service.serviceProfile.currency || 'AUD'
                    });
                    row.percentMargin = angular.extend(angular.copy(marginValue), {
                        value: row.marginPercent,
                        valueFormatted: row.marginPercent + ' %'
                    });
                 
                    row.zoneFrom = angular.extend(angular.copy(zone), {
                        value: row.zoneFrom
                    });
                    row.zoneTo = angular.extend(angular.copy(zone), {
                        value: row.zoneTo
                    });

                    tableStructure.data.push(row);
                    if(createCopy)
                        dataCopy.push(angular.copy(row));
                });
            }

            function resetTableData() {
                tableStructure.data.length = 0;
                angular.forEach(dataCopy, data=>tableStructure.data.push(data));
            }

            function addNewMargin() {
                tableStructure.form.$setSubmitted();
                if(tableStructure.form.$invalid){
                    return false;
                }
                const onEditMode = tableStructure.data.find(data=>{
                    if(data.editMode){
                        data.isSelected = true;
                        return true
                    }
                    return false
                });
                if(onEditMode){
                    return false;
                }
                $timeout(()=>{
                    tableStructure.form.$setUntouched();
                    tableStructure.form.$setPristine();
                    const row = {
                        zoneFrom: angular.copy(zone),
                        zoneTo: angular.copy(zone),
                        fixedMargin: angular.extend(angular.copy(marginValue),{
                            addOn: service.serviceProfile.currency || 'AUD'
                        }),
                        percentMargin: angular.copy(marginValue),
                        actions: actionBtns(true),
                        editMode: true,
                        isNewMargin: true
                    };
                    tableStructure.data.push(row);
                    $rootScope.$broadcast('postcodeMarginsTableUpdated', 'updated');
                });
            }

            function getPostcodeMarginFormatted() {
                let filteredData = tableStructure.data.filter(value=>{
                    return !value.editMode;
                });

                return filteredData.map( row => {
                    return {
                        country: angular.getObjVal(row, 'countryObj.value.code'),
                        zoneFrom: angular.getObjVal(row, 'zoneFrom.value.id'),
                        zoneTo: angular.getObjVal(row, 'zoneTo.value.id'),
                        marginFixed: angular.getObjVal(row, 'fixedMargin.value') || 0,
                        marginPercent: angular.getObjVal(row, 'percentMargin.value') || 0
                    }
                });
            }

            function getOpenForms(){
                let openFrm =  tableStructure.data.filter(value=>{
                    if(value.editMode) {
                        return value;
                    }
                });
                return openFrm.length !== 0 ? true : false;
            }

            this.tableData = tableStructure;
            this.refreshTable = buildTableData;
            this.resetTableData = resetTableData;
            this.addNewMargin = addNewMargin;
            this.getPostcodeMarginFormatted = getPostcodeMarginFormatted;
            this.getOpenForms = getOpenForms;
        }
    }
})();


// WEBPACK FOOTER //
// ./js/services/tables/ZoneBaseMarginTableService.js